import React from 'react';
import './SurveyRating.css';
import PropTypes from 'prop-types';
import startDarkGray from 'images/star_dark_gray.svg';
import startGray from 'images/star_gray.svg';

export default function SurveyRating(props) {
  return (
    <div className="survey-rating">
      {props.rating === null || props.rating === 0 ? (
        props.showWaiting ? (
          <span className="waiting">Waiting</span>
        ) : (
          <span>N/A</span>
        )
      ) : (
        [1, 2, 3].map((rating) => {
          if (rating <= props.rating) {
            return (
              <img key={rating} src={startDarkGray} alt="start-dark-gray" />
            );
          }
          return <img key={rating} src={startGray} alt="start-gray" />;
        })
      )}
    </div>
  );
}

SurveyRating.propTypes = {
  rating: PropTypes.oneOf([0, 1, 2, 3]),
  showWaiting: PropTypes.bool,
};

SurveyRating.defaultProps = {
  rating: 0,
  showWaiting: true,
};



// WEBPACK FOOTER //
// ./src/components/admin/surveys/SurveyRating.js